export default __webpack_public_path__ + "static/media/mobile.f82d7322.png";